'use client'

import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import Image from 'next/image'

interface BestSellerProductCarouselProps {
  images: string[]
  productTitle: string
}
export const BestSellerProductCarousel = ({
  images,
  productTitle,
}: BestSellerProductCarouselProps) => {
  return (
    <Carousel
      opts={{
        loop: true,
        align: 'center',
        slidesToScroll: 1,
      }}
      plugins={[
        Autoplay({
          delay: 5000,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
        }),
      ]}
      className='w-full'
    >
      <CarouselContent className='relative ml-0 h-full w-full'>
        {images.map((img, i) => (
          <CarouselItem key={i} className='pl-0'>
            <div
              className='cursor-pointer overflow-hidden rounded-lg'
              tabIndex={0}
              role='button'
              aria-label={`Xem ảnh sản phẩm ${productTitle}`}
            >
              <Image
                src={ImageHelper.getImageUrl(img)}
                alt={productTitle}
                width={800}
                height={500}
                className='h-full w-full object-cover'
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselDots />
    </Carousel>
  )
}
